module.exports = __webpack_public_path__ + "img/menu-personal-yellow.bca07ef0.svg";